import clarity from '@microsoft/clarity';
import { getEnvironment, APP_ENV } from 'src/utils/env';

let clarityInitialized = false;

export function initClarity() {
  const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
  const environment = getEnvironment();

  const isEnabled = environment !== APP_ENV.LOCAL;

  if (!projectId || !isEnabled) {
    if (environment === APP_ENV.LOCAL) {
      console.warn('[Clarity] Disabled in LOCAL environment.');
    } else if (!projectId) {
      console.warn('[Clarity] Missing REACT_APP_CLARITY_PROJECT_ID.');
    }
    return;
  }

  if (clarityInitialized || window.__clarity_initialized) {
    return;
  }

  try {
    clarity.init(projectId);

    window.__clarity_initialized = true;
    clarityInitialized = true;

    if (environment === APP_ENV.DEVELOPMENT) {
      console.info('[Clarity] Initialized in DEVELOPMENT');
    }
  } catch (err) {
    if (environment === APP_ENV.DEVELOPMENT) {
      console.error('[Clarity] Initialization failed', err);
    }
  }
}